import { render, staticRenderFns } from "./chat-item.vue?vue&type=template&id=8c02052c&"
import script from "./chat-item.vue?vue&type=script&lang=js&"
export * from "./chat-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports